import { GitFork } from "lucide-react";
import { Button } from "~/components/ui/button";

interface TableLineageButtonProps {
  onClick: () => void;
}

export const TableLineageButton = ({ onClick }: TableLineageButtonProps) => (
  <Button variant="outline" size="sm" onClick={onClick}>
    <GitFork className="mr-1.5 size-3.5" />
    View Lineage
  </Button>
);
